import { login } from '../api/client';

export function LoginPage() {
  return (
    <div className="center-screen">
      <div className="card login-card">
        <h1>
          Tricord <span style={{ color: 'var(--tc-accent)' }}>Quotes</span>
        </h1>
        <p className="muted">Sign in with your Microsoft 365 account to build and track quotes.</p>
        <button className="primary" style={{ marginTop: '1rem' }} onClick={() => login('/')}>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
